// Runtime backend URL override. On Hostinger, edit /config.js (served alongside
// index.html) — no rebuild needed. Falls back to the build-time env var.
export const API =
    (typeof window !== "undefined" && window.__TIMBOTIC_API__) ||
    process.env.REACT_APP_BACKEND_URL;
